import styled from '@emotion/styled';

const TableComponent = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const TableHeader = styled.thead``;

const TableBody = styled.tbody``;

const TableRow = styled.tr<{ isExpanded?: boolean }>`
  border-bottom: 1px solid
    ${({ theme }) => theme.tokens.color.alias.cm.border['border-subtle'].value};

  ${({ isExpanded, theme }) =>
    isExpanded &&
    `
    background-color: ${theme.tokens.color.alias.cm.bg['bg-neutral-subtle'].value};
    border-bottom: none;
  `}
`;

const TableHeaderCell = styled.th<{ colSpan?: number }>`
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.8rem;
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  border-bottom: 2px solid
    ${({ theme }) => theme.tokens.color.alias.cm.border['border-subtle'].value};
`;

const TableCell = styled.td<{ colSpan?: number }>`
  padding: 1rem;
  vertical-align: top;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TableSubRowCell = styled.td<{ colSpan?: number }>`
  padding: 0.5rem 1rem;
  vertical-align: top;
`;

const TableSubRow = styled.tr<{ isExpanded?: boolean }>`
  background-color: ${({ theme }) =>
    theme.tokens.color.alias.cm.bg['bg-neutral-subtle'].value};
  opacity: 0.8;
  border-top: none;

  ${({ isExpanded }) =>
    isExpanded &&
    `
    display: table-row;
  `}
`;

export {
  TableBody,
  TableCell,
  TableComponent,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableSubRow,
  TableSubRowCell,
  TableWrapper,
};
